import { JaarPeriode } from '@/enums/Timespan'
import { IResultCollection, IResultUser } from '@/interfaces/IResult'
import axios from 'axios'

export default class LooqinSociaalEmotioneelResultService {
    getOverzicht(period: JaarPeriode) {
        return axios.get<IResultCollection>(`/api/Frontend/Resultaten/Looqin/Overzicht/SociaalEmotioneel/periode/${period}`)
    }
    getVak(vakLabelId: number, period: JaarPeriode) {
        return axios.get<IResultUser[]>(`/api/Frontend/Resultaten/Looqin/Vak/${vakLabelId}/SociaalEmotioneel/periode/${period}`)
    }

    getLeerling(leerlingId: number, period: JaarPeriode) {
        return axios.get<IResultCollection>(`/api/Frontend/Resultaten/Looqin/Leerling/${leerlingId}/SociaalEmotioneel/periode/${period}`)
    }
}

export const looqinSociaalEmotioneelResultService: LooqinSociaalEmotioneelResultService = new LooqinSociaalEmotioneelResultService()
